import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class TenantQueryCriteriaClass extends BaseCriteriaModel {
  // hdr table
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();

  //ext table
  ext_type?: Optional<string> = Optional.empty();
  ext_code?: Optional<string> = Optional.empty();
  ext_option?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  created_date?: Optional<string> = Optional.empty();
  updated_date?: Optional<string> = Optional.empty();

}

export class TenantCriteriaModelQuery {
  query = '';

  constructor(tenantCriteriaModel: TenantQueryCriteriaClass) {

    if (!tenantCriteriaModel) {
      return;
    }

    this.query += tenantCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += tenantCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');

    this.query += tenantCriteriaModel.ext_type.filter(x => x !== '').map(x => '&ext_type=' + x).orElse('');
    this.query += tenantCriteriaModel.ext_code.filter(x => x !== '').map(x => '&ext_code=' + x).orElse('');
    this.query += tenantCriteriaModel.ext_option.filter(x => x !== '').map(x => '&ext_option=' + x).orElse('');
    this.query += tenantCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += tenantCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += tenantCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += tenantCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += tenantCriteriaModel.created_date.filter(x => x !== '').map(x => '&created_date=' + x).orElse('');
    this.query += tenantCriteriaModel.updated_date.filter(x => x !== '').map(x => '&updated_date=' + x).orElse('');

    this.query += '&status=' + tenantCriteriaModel.status;
    this.query += '&orderBy=' + tenantCriteriaModel.orderBy;
    this.query += '&order=' + tenantCriteriaModel.order;
    this.query += '&offset=' + tenantCriteriaModel.offset + '&limit=' + tenantCriteriaModel.limit;
  }
}
